import locationImage1 from '../images/location/img_l_10.jpeg';
import locationImage2 from '../images/location/img_l_20.jpg';
import locationImage3 from '../images/location/img_l_25.jpg';
import locationImage4 from '../images/location/img_l_30.jpg';
import locationImage5 from '../images/location/img_l_40.jpg';
import locationImage6 from '../images/location/img_l_50.jpg';
import locationImage7 from '../images/location/img_l_60.jpeg';
import locationImage8 from '../images/location/img_l_65.jpg';

export const locationGalleryImages = [
  {
    id: 1,
    src: locationImage1,
    alt: 'Villa Mandragora beneath the mountains on the Bay of Kotor',
  },
  {
    id: 2,
    src: locationImage2,
    alt: 'Sailing boat on the Bay of Kotor beneath the mountains',
  },
  {
    id: 3,
    src: locationImage3,
    alt: 'Small boat moored in the calm waters of the Bay of Kotor',
  },
  {
    id: 4,
    src: locationImage4,
    alt: 'Historic stone waterfront of Perast',
  },
  {
    id: 5,
    src: locationImage5,
    alt: 'Stone passage in Kotor Old Town',
  },
  {
    id: 6,
    src: locationImage6,
    alt: 'Mountain path on Lovćen at sunset',
  },
  {
    id: 7,
    src: locationImage7,
    alt: 'St. George island seen from above in the Bay of Kotor',
  },
  {
    id: 8,
    src: locationImage8,
    alt: 'Our Lady of the Rocks and St. George islands near Perast',
  },
];

export const locationImages = {
  hero: locationGalleryImages[0],
  bay: locationGalleryImages[1],
  perast: locationGalleryImages[3],
  kotor: locationGalleryImages[4],
  lovcen: locationGalleryImages[5],
  byWater: locationGalleryImages[6],
};
